'use strict';
angular.module('app').controller('OfferController',['$scope','$window','$location','tools','parameters','modelstore','webservice','errorlog','localStorageService',
                                            function($scope,$window,$location,tools,parameters,modelstore,webservice,errorlog,localStorageService) {

  var script='public/offer';
  $scope.model={};
  var model=$scope.model;

  $scope.create = function(){
    var visit=tools.clone(model.visit);
    if (model.startdate) {
      visit.startdate=tools.dateFromJava(model.startdate);
      visit.enddate=new Date(model.startdate);
      visit.enddate.setDate(model.startdate.getDate()+(visit.duration-1));
      visit.enddate=tools.dateFromJava(visit.enddate);
    }
    var budgetQuotationnote=tools.clone(model.budgetQuotationnote);
    if(budgetQuotationnote.body.length!=="") {
      budgetQuotationnote.body="Budget pp: "+budgetQuotationnote.body;
    }
    webservice.exclusiveCall('createQuotation',{
      'lang':('lang' in $window.outdoorArgs)?$window.outdoorArgs.lang:'nl',
      'contacts':tools.whitelist([model.owningContact,model.communicationContact],['firstname','name','gsm','email','iscompany','vatnumber']),
      'visit':tools.whitelist(visit,['owningcontact','communicationcontact','startdate','enddate','comment','quotationcomment','quotationparticipants','quotationpriceperperson','vatnumber']),
      'quotationnotes':[tools.whitelist(budgetQuotationnote,['body'])]
    }, script, model).then($scope.redirectWhenFinished);
  };

  $scope.redirectWhenFinished = function() {
    $scope.resetModel();
    model.finished='true';
    if($location.host().indexOf("adventure-valley")!==-1 || $location.host().indexOf("localhost")!==-1) {
      $window.location.href=$location.protocol()+"://"+$location.host()+tools.lang({'en':'/en/business/thankyou','nl':'/nl/bedrijven/bedankt','fr':'/entreprise/devis/merci'});
    }
  };
  
  $scope.resetModel = function() {
    modelstore.cleanModel(['visits','contacts'],model);
    model.created=tools.today();
    model.startdate='';
    model.owningContact={
      'id':tools.getMinIdMinusOne(tools.toArray(model.contacts)),
      'name':'',
      'iscompany':'1',
      'vatnumber':''
    };
    modelstore.addRecord('contacts',model.owningContact,model);
    model.communicationContact={
      'id':tools.getMinIdMinusOne(tools.toArray(model.contacts)),
      'firstname':'',
      'name':'',
      'gsm':'',
      'email':'',
      'iscompany':'0'
    };
    modelstore.addRecord('contacts',model.communicationContact,model);
    model.visit={
      'id':'-1',
      'owningcontact':model.owningContact.id,
      'communicationcontact':model.communicationContact.id,
      'duration':1,
      'quotationcomment':'',
      'quotationparticipants':0,
      'quotationpriceperperson':0
    };
    modelstore.addRecord('visits',model.visit,model);
    model.budgetQuotationnote={
      'body':''
    };
    model.finished='false';
    tools.initAttributes(model,{
      'visits':{}
    });
  };

  model.dateOptions={
    maxDate: new Date(2099,11,31),
    minDate: new Date(2000,0,1),
    startingDay: 1
  };

  tools.initAttributes(model,{
    'contacts':{}
  });
  $scope.resetModel();
  var modelVarsToBind=['created','startdate','visit','budgetQuotationnote','finished'];
  var i;
  for(i in modelVarsToBind) {
    var modelVarBeingBound=modelVarsToBind[i];
    localStorageService.bind($scope,['model',modelVarBeingBound],'publicOfferModel'+modelVarBeingBound,model[modelVarBeingBound]);
  }
  if(model.created!==tools.today()) {
    $scope.resetModel();
  } else {
    modelstore.addRecord('visits',model.visit,model);
  }

}]);